import {
    CREATE_DEFAULT_STYLE_MASTER_FAILURE,
    CREATE_DEFAULT_STYLE_MASTER_REQUEST,
    CREATE_DEFAULT_STYLE_MASTER_SUCCESS,
    CREATE_USER_FORM_DEFAULT_STYLE_MASTER,
    DEFAULT_STYLE_MASTER_SET_ACTIVE_FAILURE,
    DEFAULT_STYLE_MASTER_SET_ACTIVE_REQUEST,
    DEFAULT_STYLE_MASTER_SET_ACTIVE_SUCCESS,
    DELETE_DEFAULT_STYLE_MASTER_FAILURE,
    DELETE_DEFAULT_STYLE_MASTER_REQUEST,
    DELETE_DEFAULT_STYLE_MASTER_SUCCESS,
    FETCH_DEFAULT_STYLE_MASTER_FAILURE,
    FETCH_DEFAULT_STYLE_MASTER_REQUEST,
    FETCH_DEFAULT_STYLE_MASTER_SUCCESS,
    FETCH_SINGLE_DEFAULT_STYLE_MASTER_FAILURE,
    FETCH_SINGLE_DEFAULT_STYLE_MASTER_REQUEST,
    FETCH_SINGLE_DEFAULT_STYLE_MASTER_SUCCESS,
    RESET_DEFAULT_STYLE_MASTER_USER_FORM,
    TYPES_OF_MATERIALS_FAILURE,
    TYPES_OF_MATERIALS_REQUEST,
    TYPES_OF_MATERIALS_SUCCESS,
    UPDATE_DEFAULT_STYLE_MASTER_FAILURE,
    UPDATE_DEFAULT_STYLE_MASTER_REQUEST,
    UPDATE_DEFAULT_STYLE_MASTER_SUCCESS
} from './defaultStyleMaster.actionsType';
import ConstantApi from '../../ConstantApi';
import axiosCall from '../axiosCall';

// FETCH AREA MASTER
export let fetchDefaultStyleMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.defaultStyleMasterGET,
        responseTypeRequest: FETCH_DEFAULT_STYLE_MASTER_REQUEST,
        responseTypeSuccess: FETCH_DEFAULT_STYLE_MASTER_SUCCESS,
        responseTypeFailure: FETCH_DEFAULT_STYLE_MASTER_FAILURE
    };
    return axiosCall(config);
};
export let fetchDefaultStyleMasterByID = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.defaultStyleMasterGET}/${id}`,
        responseTypeRequest: FETCH_DEFAULT_STYLE_MASTER_REQUEST,
        responseTypeSuccess: FETCH_DEFAULT_STYLE_MASTER_SUCCESS,
        responseTypeFailure: FETCH_DEFAULT_STYLE_MASTER_FAILURE
    };
    return axiosCall(config);
};

//Fetch Country List
export let fetchTypesOfMaterials = (codeId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${codeId}`,
        responseTypeRequest: TYPES_OF_MATERIALS_REQUEST,
        responseTypeSuccess: TYPES_OF_MATERIALS_SUCCESS,
        responseTypeFailure: TYPES_OF_MATERIALS_FAILURE,
        payload: codeId
    };
    return axiosCall(config);
};

export let setActiveForDefaultStyleMaster = (id, productId) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.defaultStyleMasterGET_SET_ACTIVE}/${id}`,
        responseTypeRequest: DEFAULT_STYLE_MASTER_SET_ACTIVE_REQUEST,
        responseTypeSuccess: DEFAULT_STYLE_MASTER_SET_ACTIVE_SUCCESS,
        responseTypeFailure: DEFAULT_STYLE_MASTER_SET_ACTIVE_FAILURE,
        getAllData: productId ? fetchDefaultStyleMasterByID(productId) : fetchDefaultStyleMaster()
    };
    return axiosCall(config);
};


// create user Form
export let createDefaultStyleMasterUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_DEFAULT_STYLE_MASTER, payload: { key, value } });
    };
};

// CREATE AREA MASTER
// "fldId": 0,
//   "fldFKSleeveType": 0,
//   "fldFKNeckType": 0,
//   "fldFKTypeOfFit": 0,
//   "fldFKYarn": 0,
//   "fldFKFabricType": 0,
//   "fldIsActive": true,
//   "fldEnteredSysId": "string",
//   "fldCreatedBy": 0,
//   "fldCreatedDt": "2022-07-29T12:06:16.995Z",
//   "fldPreparedBy": "string",
//   "fldPreparedOn": "2022-07-29T12:06:16.995Z",
//   "fldIsVerified": true,
//   "fldVerifiedBy": "string",
//   "fldVerifiedOn": "2022-07-29T12:06:16.995Z",
//   "fldIsAuthorized": true,
//   "fldAuthorizedBy": "string",
//   "fldAuthorizedOn": "2022-07-29T12:06:16.995Z"

export let createDefaultStyleMaster = (userform, modalClose, id) => {
    console.log('userform action>>>>>>>>>>>>', userform);
    let { fldFKSleeveType, fldFKNeckType, fldFKTypeOfFit, ipv4, fldFKYarn, fldFKFabricType, fldFKProdCategories, fldFKProductType } =
        userform;
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldFKSleeveType: parseInt(fldFKSleeveType),
        fldFKNeckType: parseInt(fldFKNeckType),
        fldFKTypeOfFit: parseInt(fldFKTypeOfFit),
        fldFKYarn: parseInt(fldFKYarn),
        fldFKFabricType: parseInt(fldFKFabricType),
        fldFKProdCategories: parseInt(fldFKProdCategories),
        fldFKProductType: parseInt(fldFKProductType),
        fldProductType: 'string',
        fldIsActive: true,
        fldEnteredSysId: ipv4,
        fldCreatedBy: 0,
        fldCreatedDt: today.toISOString(),
        fldPreparedBy: 'string',
        fldPreparedOn: '2022-07-29T12:06:16.995Z',
        fldIsVerified: true,
        fldVerifiedBy: 'string',
        fldVerifiedOn: '2022-07-29T12:06:16.995Z',
        fldIsAuthorized: true,
        fldAuthorizedBy: 'string',
        fldAuthorizedOn: '2022-07-29T12:06:16.995Z'
    });
    console.log('data :>> ', data);
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.defaultStyleMasterPOST}`,
        responseTypeRequest: CREATE_DEFAULT_STYLE_MASTER_REQUEST,
        responseTypeSuccess: CREATE_DEFAULT_STYLE_MASTER_SUCCESS,
        responseTypeFailure: CREATE_DEFAULT_STYLE_MASTER_FAILURE,
        resetFormData: RESET_DEFAULT_STYLE_MASTER_USER_FORM,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: id ? fetchDefaultStyleMasterByID(id) : fetchDefaultStyleMaster()
    };
    return axiosCall(config);
};

// GET SINGLE AREA MASTER
export let getSingleDefaultStyleMaster = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.defaultStyleMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_DEFAULT_STYLE_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_DEFAULT_STYLE_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_DEFAULT_STYLE_MASTER_FAILURE,
        singlApiArray: [
            fetchTypesOfMaterials(19), //Sleeve Type
            fetchTypesOfMaterials(11), // Neck Type
            fetchTypesOfMaterials(20), // Type of Fit
            fetchTypesOfMaterials(15), //Yarn
            fetchTypesOfMaterials(17) //Fabric Type
        ]
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER

//     "fldId": 3,
//     "fldFKCountry": 1045,
//     "fldCountry": "India1",
//     "fldFKState": 4,
//     "fldState": "TN",
//     "fldFKCity": 1045,
//     "fldCity": "TUP",
//     "fldFKArea": 1045,
//     "fldArea": "SAP",
//     "fldFKPincode": 1045,
//     "fldPincode": "641-652",
//     "fldIsActive": true,
//     "fldEnteredSysId": "192.16.12.170",
//     "fldCreatedBy": 1,
//     "fldCreatedDt": "2022-05-16T09:48:03.527",
//     "fldModifiedBy": 0,
//     "fldModifiedDt": "0001-01-01T00:00:00",
//     "fldDeletedBy": 0,
//     "fldDeletedDt": "0001-01-01T00:00:00"

export let updateDefaultStyleMaster = (id, formData, productId) => {
    let {
        fldFKSleeveType,
        fldFKNeckType,
        fldFKTypeOfFit,
        ipv4,
        fldFKYarn,
        fldFKFabricType,
        fldCreatedBy,
        fldCreatedDt,
        fldProductType,
        fldFKProdCategories,
        fldFKProductType
    } = formData;
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKSleeveType: parseInt(fldFKSleeveType),
        fldFKNeckType: parseInt(fldFKNeckType),
        fldFKTypeOfFit: parseInt(fldFKTypeOfFit),
        fldFKYarn: parseInt(fldFKYarn),
        fldFKFabricType: parseInt(fldFKFabricType),
        fldFKProdCategories: parseInt(fldFKProdCategories),
        fldFKProductType: parseInt(fldFKProductType),
        fldProductType: fldProductType,
        fldIsActive: false,
        fldEnteredSysId: ipv4,
        fldCreatedBy: fldCreatedBy,
        fldCreatedDt: fldCreatedDt,
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldPreparedBy: 'string',
        fldPreparedOn: '2022-07-29T12:24:47.637Z',
        fldIsVerified: true,
        fldVerifiedBy: 'string',
        fldVerifiedOn: '2022-07-29T12:24:47.637Z',
        fldIsAuthorized: true,
        fldAuthorizedBy: 'string',
        fldAuthorizedOn: '2022-07-29T12:24:47.637Z'
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.defaultStyleMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_DEFAULT_STYLE_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_DEFAULT_STYLE_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_DEFAULT_STYLE_MASTER_FAILURE,
        resetFormData: RESET_DEFAULT_STYLE_MASTER_USER_FORM,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: productId ? fetchDefaultStyleMasterByID(productId) : fetchDefaultStyleMaster()
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteDefaultStyleMaster = (id, productId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.defaultStyleMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_DEFAULT_STYLE_MASTER_REQUEST,
        responseTypeSuccess: DELETE_DEFAULT_STYLE_MASTER_SUCCESS,
        responseTypeFailure: DELETE_DEFAULT_STYLE_MASTER_FAILURE,
        modalClose: true,
        getAllData: productId ? fetchDefaultStyleMasterByID(productId) : fetchDefaultStyleMaster()
    };
    return axiosCall(config);
};
